module.exports = __webpack_public_path__ + "assets/images/electoral-college/map/bg.jpg?v=be710157";